import React from "react";
import DOMPurify from "dompurify";
import { usePanelSimpleStore } from "../../../../../stores/use-panel-simple-store";
import { useEffect } from "react";
import {
  StyledEditableTextarea,
  StyledTextareaCalculator,
} from "../../../../../components/inline-edit/styled";

function EditableText({ data, isEditable, field }) {
  const { setData } = usePanelSimpleStore((state) => ({
    setData: state.setData,
  }));

  const textareaRef = React.useRef();
  const textareaHelperRef = React.useRef();

  const value = data[field];

  useEffect(() => {
    if (!data.id || !isEditable) return;

    const resizeObserver = new ResizeObserver((entries) => {
      const entry = entries[0];
      const helperHeight = entry.contentRect.height;
      if (textareaRef?.current) {
        textareaRef.current.style.height = `${helperHeight}px`;
      }
    });
    const element = document.getElementById(
      `${data.id}-${field}-panel-content-text-area-helper`
    );
    if (element) {
      resizeObserver.observe(element);
    }
  }, [data.id, isEditable, value]);

  return (
    <>
      {isEditable ? (
        <>
          <StyledEditableTextarea
            ref={textareaRef}
            value={value}
            onInput={(e) => setData({ [field]: e.target.value })}
          />
          <StyledTextareaCalculator
            id={`${data.id}-${field}-panel-content-text-area-helper`}
            ref={textareaHelperRef}
            width="100%"
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(value) }}
          />
        </>
      ) : (
        value
      )}
    </>
  );
}

export default EditableText;
